import React, { memo } from "react";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { formatDate } from "config/constant";

const InfoPromotion = props => {
	const classes = useStyles();
	const { campaignDetail } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				{campaignDetail?.name}
			</Grid>
			<Grid classes={{ root: classes.textTime }}>
				TG áp dụng:{" "}
				<span className={classes.valueTime}>
					{" "}
					{`${formatDate(campaignDetail?.startTime)} - ${formatDate(
						campaignDetail?.endTime
					)}`}
				</span>
			</Grid>
		</Grid>
	);
};

export default memo(InfoPromotion);
